import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import styled from "styled-components";
import { DeclarationOfTruth } from "csv-package";

import spacing from "../../../theme/spacing";

import PageTitle from "../../../components/PageTitle";
import QuestionsFrame from "../../../components/QuestionsFrame";

import narrativeGenerator from "../../../helpers/narrativeGenerator";
import { ApplicationContext } from "../../../reducers/applicationFrame";
import { FlatApplciationType } from "../../../types";

import template from "../narrativeTemplate";
import getCourtByPostcode from "../../../helpers/getCourtByPostcode";
import getCourtById from "../../../helpers/getCourtById";
import colors from "../../../theme/colors";

const Review = () => {
  const {
    state: { schema },
  } = React.useContext(ApplicationContext);
  const { values, setFieldValue } = useFormikContext<FlatApplciationType>();
  const courtName = getCourtById(values.CourtID)?.name || "your local court";

  useEffect(() => {
    if (!values.CourtID) {
      const courtByPostcode = getCourtByPostcode(
        String(values.appl_det_addr_postcode),
      );
      if (!courtByPostcode) return;
      setFieldValue("CourtID", courtByPostcode.court_id);
    }
    // eslint-disable-next-line
  }, []);

  let displayNarrative = narrativeGenerator(values, template, schema, true);
  try {
    if (values.Status !== "initiated") {
      displayNarrative = values.Narrative.split("\n")
        .join("<br />")
        .split("\r")
        .join("<br />");
    }
  } catch (e) {
    // do nothing
  }

  return (
    <>
      <PageTitle
        heading="Review your final statement"
        description={
          <>
            The statement below has been automatically prepared from the information you have provided. Please review this statement and add or change any final information you believe is important by selecting previous pages and making any changes needed.
          </>
        }
      />
      <Narrative
        dangerouslySetInnerHTML={{
          __html: displayNarrative,
        }}
      />
      <QuestionsFrame>
        <h2>Next Steps</h2>
        <p>
          We will send your application to <strong>{courtName}</strong>. To learn more about your local court see{" "}
           <a
            href="https://www.mcv.vic.gov.au/going-court/find-court"
            target="_blank"
            rel="noreferrer"
            title="Find a court"
            style={{ color: colors.blue }}
          >
            here
          </a>
          .
        </p>
        <p>
          Court staff will contact you about your application using the contact information you provided in this application.
        </p>
        <p>
          If you told us, it is not safe to contact you, you will need to contact <strong>{courtName}</strong>. Please do this as soon as possible in the next seven (7) business days so that we can progress your application.
        </p>
      </QuestionsFrame>
      <QuestionsFrame>
        <DeclarationOfTruth
          applicantName={`${values.appl_det_giv_nam} ${values.appl_det_fam_nam}`}
          applicantDOB={values.appl_det_dob + ""}
          onCheckboxChange={() =>
            setFieldValue(
              "declaration_of_truth",
              !Boolean(values.declaration_of_truth),
            )
          }
          checked={Boolean(values.declaration_of_truth)}
        />
      </QuestionsFrame>
    </>
  );
};

export default Review;

const Narrative = styled.div`
  padding: 0 ${spacing.gutters}px 0;
  line-height: 1.4;

  h3: {
    font-size: 1.375rem;
    line-height: 1.36;
    margin: 2em 0 1em;
  }

  h3:first-child {
    margin-top: 0;
  }
`;
